import getLocalePrefix from './getLocalePrefix';

// Fetches an alternate product template (e.g. ?view=atc-popup) and returns it
// parsed as a document, so callers can pick the markup they need out of it.
const fetchProductView = async (handle, view) => {
  const url = `${location.origin}${getLocalePrefix()}/products/${encodeURIComponent(handle)}?view=${view}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Product view request failed: ${response.status}`);
  }
  const html = await response.text();
  return new DOMParser().parseFromString(html, 'text/html');
};

export default fetchProductView;
